import { lazy, useEffect, useState } from "react";

import { Redirect, Route, useLocation } from "react-router-dom";

import { useApp } from "@ip-contexts/app-context";
import { ProtectedRoutes } from "@ip-widgets/Tailwind/auth";

const Account = lazy(() => import("./Account"));

const Contract = lazy(() => import("./Contract"));
const ContractEdit = lazy(() => import("./Contract/Edit"));
const ContractCreate = lazy(() => import("./Contract/Create"));
const CustomContract = lazy(() => import("./Contract/CustomContract"));
const PreCreate = lazy(() => import("./Contract/PreCreate"));

const Documents = lazy(() => import("./Documents"));

export default function Me() {
  const [loading, setLoading] = useState(true);
  const { state, dispatch } = useApp();
  const location = useLocation();

  const department = "me";
  const departmentPath = `/${department}`;
  const isMainPath = () => location.pathname === "/" + department;

  useEffect(() => {
    if (
      (state.department !== department || state.path !== location.pathname) &&
      state.status !== "pending"
    ) {
      dispatch({
        type: "start update",
        department,
        path: location.pathname,
      });
    }
  }, [dispatch, state.department, state.status, state.path, location.pathname]);

  useEffect(() => {
    if (state.department === department && state.path === location.pathname) {
      dispatch({
        type: "finish update",
      });
    }
  }, [dispatch, state.department, state.path, location.pathname]);

  useEffect(() => {
    if (state.status === "resolved") {
      setLoading(false);
    }
  }, [state.status]);

  if (loading) {
    return <div />;
  }
  return (
    <>
      {isMainPath() && (
        <Redirect
          exact
          from={departmentPath}
          to={`${departmentPath}/account`}
        />
      )}

      <ProtectedRoutes path={departmentPath}>
        <Route exact component={Account} path={"/account"} />

        <Route exact component={Documents} path={"/documents"} />

        <Route exact component={Contract} path={"/contracts"} />
        <Route exact component={ContractCreate} path={"/contracts/new"} />
        <Route exact component={PreCreate} path={"/contracts/pre"} />

        <Route component={ContractEdit} path={"/contracts/:id"} />
        <Route component={CustomContract} path={"/contracts/custom_contract"} />
      </ProtectedRoutes>
    </>
  );
}
